import { Field as FieldPrimitive } from "@base-ui/react/field";
import { mergeProps } from "@base-ui/react/merge-props";
import * as React from "react";
import { cn } from "@/utils/class-name";

export type TextareaProps = React.ComponentPropsWithoutRef<"textarea"> &
    React.RefAttributes<HTMLTextAreaElement> & {
        size?: "sm" | "default" | "lg" | number;
        unstyled?: boolean;
    };

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, size = "default", unstyled = false, ...props }, ref) => (
        <span
            className={
                cn(
                    !unstyled &&
                        "relative inline-grid w-full rounded-lg border border-input bg-background not-dark:bg-clip-padding text-base shadow-xs/5 ring-ring/24 transition-shadow before:pointer-events-none before:absolute before:inset-0 before:rounded-[calc(var(--radius-lg)-1px)] has-focus-visible:has-aria-invalid:border-destructive/64 has-focus-visible:has-aria-invalid:ring-destructive/16 has-aria-invalid:border-destructive/36 has-focus-visible:border-ring has-disabled:opacity-55 has-[:disabled,:focus-visible,[aria-invalid]]:shadow-none has-focus-visible:ring-[3px] not-has-disabled:has-not-focus-visible:not-has-aria-invalid:before:shadow-[0_1px_--theme(--color-black/4%)] sm:text-control dark:bg-input/32 dark:has-aria-invalid:ring-destructive/24 dark:not-has-disabled:has-not-focus-visible:not-has-aria-invalid:before:shadow-[0_-1px_--theme(--color-white/6%)]",
                    className,
                ) || undefined
            }
            data-size={size}
            data-slot={"textarea-control"}
        >
            <FieldPrimitive.Control
                ref={ref}
                value={props.value}
                defaultValue={props.defaultValue}
                disabled={props.disabled}
                id={props.id}
                name={props.name}
                render={(defaultProps: React.ComponentProps<"textarea">) => (
                    <textarea
                        className={cn(
                            "field-sizing-content min-h-17.5 w-full rounded-[inherit] px-[calc(--spacing(3)-1px)] py-[calc(--spacing(1.5)-1px)] text-foreground outline-none placeholder:text-muted-foreground/72 max-sm:min-h-20.5",
                            size === "sm" &&
                                "min-h-16.5 px-[calc(--spacing(2.5)-1px)] py-[calc(--spacing(1)-1px)] max-sm:min-h-19.5",
                            size === "lg" && "min-h-18.5 py-[calc(--spacing(2)-1px)] max-sm:min-h-21.5",
                        )}
                        data-slot={"textarea"}
                        {...mergeProps(defaultProps, props)}
                    />
                )}
            />
        </span>
    ),
);
Textarea.displayName = "Textarea";

export { FieldPrimitive };
